import { render } from "./NotificationAdd.vue?vue&type=template&id=c4d339aa"
import script from "./NotificationAdd.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationAdd.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/modules/notification/components/NotificationAdd.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c4d339aa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c4d339aa', __exports__)) {
    api.reload('c4d339aa', __exports__)
  }
  
  module.hot.accept("./NotificationAdd.vue?vue&type=template&id=c4d339aa", () => {
    api.rerender('c4d339aa', render)
  })

}


export default __exports__